import gql from 'graphql-tag'
import {
  userGql,
  shortViewerGql,
  fullViewerGql,
  onboarding,
  payoutStatsGql,
  payoutsDetailsGql,
  schedule
} from './fragments.gql'

export const GET_VIEWER_QUERY = gql`
  query Viewer {
    viewer: getViewer {
      id
      phone
      firstName
      lastName
      avatar
      email
      description
      credits

      sellerLocation {
        name
        place_id
        latitude
        longitude
      }
      pickupInstructions
      sellerRating

      # Alerts
      # emailVerified
      sellerProductsCount
      sellerStatus
      sellerSchedule {
        status
      }
    }
  }
`

export const GET_VIEWER_SHORT_QUERY = gql`query Viewer {
  viewer: getViewer {
    ${shortViewerGql}
  }
}
`

export const GET_PAYOUT_STATS_QUERY = gql`query PayoutStats {
  payoutStats: getPayoutStats {
    ${payoutStatsGql}
  }
}
`

export const GET_PAYOUTS_DETAILS_QUERY = gql`query Viewer {
  viewer: getViewer {
    ${payoutsDetailsGql}
  }
}
`

export const ONBOARDING_QUERY = gql`
  query Onboarding {
    viewer: getViewer {
      ${onboarding}
    }
  }
`

export const IS_EMAIL_AVAILABLE_QUERY = gql`
  query IsProfileCompleted($email: String!) {
    isEmailAvailable(email: $email)
  }
`

export const IS_PROFILE_COMPLETED_QUERY = gql`
  query IsProfileCompleted($target: UserRole!) {
    isProfileCompleted(target: $target)
  }
`

export const GET_UPCOMING_ORDERS_QUERY = gql`
  query UpcomingOrders {
    upcomingOrders: getUpcomingOrders {
      id
      status
      deliverOn
      lineItems {
        product {
          id
          name
        }
        quantity
      }
    }
  }
`

export const GET_SCHEDULE_QUERY = gql`
  query Schedule {
    viewer: getViewer {
      id
      sellerSchedule {
        ${schedule}
      }
    }
  }
`

export const UPDATE_VIEWER_MUTAION = gql`
  mutation UpdateViewer($data: UserUpdateData!) {
    updateViewer(data: $data) {
      ${fullViewerGql}
    }
  }
`

export const SETUP_PROFILE_MUTAION = gql`
  mutation UpdateViewer($data: UserUpdateData!) {
    updateViewer(data: $data) {
      ${onboarding}
    }
  }
`

export const DELETE_VIEWER_MUTAION = gql`
  mutation DeleteViewer($data: UserDeleteData!) {
    deleteViewer(data: $data) {
      ${fullViewerGql}
    }
  }
`

export const REQUEST_PHONE_VERIFICATION_MUTAION = gql`
  mutation RequestPhoneVerification($phone: String!) {
    requestPhoneVerification(phone: $phone)
  }
`

export const CHECK_VERIFICATION_CODE_MUTAION = gql`
  mutation CheckVerificationCode(
    $phone: String!
    $code: String!
    $target: UserRole
  ) {
    checkVerificationCode(phone: $phone, code: $code, target: $target) {
      token
      refreshToken
      userId
    }
  }
`

export const APPLY_PROMO_CODE_MUTAION = gql`
  mutation ApplyPromoCode($code: String!) {
    promotion: applyPromoCode(code: $code)
  }
`
